var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTypeTapeCord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#292929",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.007 28.402c-2.179 0-3.952-1.784-3.952-3.978 0-1.061.411-2.06 1.157-2.811a3.921 3.921 0 012.794-1.165h12.576a7.628 7.628 0 005.415-2.255v7.995c0 .823-.26 1.586-.697 2.214H24.007zm-3.952 2.642a7.641 7.641 0 003.952 1.105H49.04c.091 0 .166.075.166.167v13.688a.17.17 0 01-.166.167H24.007c-2.179 0-3.952-1.784-3.952-3.977v-11.15zm28.986-2.642h-5.75a5.63 5.63 0 00.452-2.214v-10.69a7.74 7.74 0 00.514-2.774C44.257 8.465 40.814 5 36.582 5H2v3.748h34.582c2.179 0 3.952 1.783 3.952 3.976s-1.773 3.977-3.952 3.977H24.006c-2.05 0-3.977.803-5.426 2.262a7.684 7.684 0 00-2.214 4.764H2v1.757h14.332v16.71c0 4.26 3.443 7.724 7.675 7.724H49.04c2.145 0 3.89-1.756 3.89-3.914V32.316c0-2.159-1.745-3.914-3.89-3.914z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12.828h12.575V11.07H2zm15.719 0h3.144V11.07h-3.144z"
  }))));
}
export default SvgIcnTypeTapeCord;